function isMac() {
  return /Mac|iPhone|iPad/.test(navigator.userAgent)
}

/**
 * Returns platform-specific keyboard symbol for modifier key.
 *
 * @param key - Modifier key type
 * @returns Symbol for the key (⌘ for Mac cmd, ^ for ctrl, ⌥ for alt, ⇧ for shift)
 */
export function formatModifierKey(key: "ctrl" | "meta" | "alt" | "shift") {
  switch (key) {
    case "ctrl":
    case "meta":
      return isMac() ? "⌘" : "CTRL"
    case "alt":
      return isMac() ? "⌥" : "ALT"
    case "shift":
      return isMac() ? "⇧" : "SHIFT"
    default:
      return ""
  }
}

/**
 * replace ctrl with modifier symbol.
 */
export function formatShortcut(shortcut: string) {
  return shortcut
    .toLowerCase()
    .replace("ctrl", formatModifierKey("ctrl"))
    .replace("meta", formatModifierKey("meta"))
    .replace("alt", formatModifierKey("alt"))
    .replace("shift", formatModifierKey("shift"))
}
